import React, { useState, useEffect, useRef } from "react";
import arrowDown from "../../../assets/icons/purple-chevron-down.svg"; 
import './styles.scss'; 

const FunctionalDropdown = ({ options = [], label, onSelect, value, placeholder = "Select an option", className = ""  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleOptionSelect = (option) => {
        onSelect(option); 
        setIsOpen(false);
    };

    const toggleDropdown = () => setIsOpen(!isOpen);

    const selectedLabel = options.find((opt) => opt.value === value)?.label || placeholder;

    return (
        <div className={`b-functional-dropdown ${className}`} ref={dropdownRef}>
            {label && <div className="dropdown-label">{label}</div>}
            <div className={`dropdown-header ${isOpen ? "open" : ""}`} onClick={toggleDropdown}>
                <span>{selectedLabel}</span>
                <img
                    src={arrowDown}
                    alt="arrow icon"
                    className={`dropdown-icon ${isOpen ? "rotate" : ""}`}
                />
            </div>
            {isOpen && (
                <div className="dropdown-list">
                    {options.length > 0 ? (
                        options.map((option, index) => (
                            <div
                                key={index}
                                className={`dropdown-item ${value === option.value ? "selected" : ""}`}
                                onClick={() => handleOptionSelect(option)}
                            >
                                {option.label}
                            </div>
                        ))
                    ) : (
                        <div className="dropdown-item no-options">No options available</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default FunctionalDropdown;
